import {launchDarkly} from 'utils/launchDarkly';
import {isBetaEnabled} from 'components/mytasks/betaVersion.function';

export const MY_TASKS_VERSION_TRAIT = 'my_tasks_version';

/** Tags the Survicate visitor with the My tasks version in use, so feedback replies can be told apart. */
export function setMyTasksVersionTrait(): void {
    // without the switch the tenant only sees the classic list, so there is nothing to tell apart
    if (!launchDarkly.companyClient?.variation('show-my-tasks-beta-switch', false)) return;

    // traits set before the SDK swaps its placeholder methods are lost, hence at click time
    const setVisitorTraits = window._sva?.setVisitorTraits;
    if (typeof setVisitorTraits !== 'function') return;

    try {
        setVisitorTraits({[MY_TASKS_VERSION_TRAIT]: isBetaEnabled() ? 'beta' : 'old'});
    } catch (e) {
        // a trait is not worth an error report, and the survey opens either way
        console.warn('Survicate setVisitorTraits failed:', e);
    }
}
